import React, { Component } from 'react'
import HelloSign from 'hellosign-embedded'
import { inject } from 'mobx-react'
import Connection from '../stores/connection.js'

const HELLOSIGN_CLIENT_ID = '492ce0d51620b33ed427edaaf1fb0253'

@inject('auth')
export default class Agreements extends Component {
  state = {
    legacy_user_agreements: [],
    loading: true
  }

  constructor(props) {
    super(props)
    this.helloSignClient = new HelloSign({ clientId: HELLOSIGN_CLIENT_ID })
  }

  componentWillMount() {
    new Connection('agreements').load().then(resp => {
      this.setState({
        legacy_user_agreements: resp.data.legacy_user_agreements,
        loading: false,
      })
    })
  }

  startSigning() {
    let signingUrl = '###'
    this.helloSignClient.open(signingUrl, {
      allowCancel: true, 
      container: document.getElementById('hellosign-document-container'),
    })
  }

  renderUserAgreement() {
  }

  renderLegacyAgreements() {
    let rows = this.state.legacy_user_agreements.map( (doc, i) => {
      return (
        <tr key={`legacy_${i}`}>
          <td>{doc.url ? <a href={doc.url} target="_blank">{doc.title}</a> : `On file with ${doc.title}`}</td>
          <td>{doc.status}</td>
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )
  }

  render() {
    return (
      <div className="container centered padded agreements">
        {false && (
        <div className="panel full padded">
          <h2>You have agreements requiring your signature.</h2>
          <p>Before you can continue, please sign the following documents...</p>
          <p>If you believe there is some other problem or need help, feel free to <a href="mailto:help@showcaseidx.com">contact support</a>.</p>
          <div id="hellosign-document-container" />
          <button onClick={() => this.startSigning()}>Start Signing!</button> 
        </div>
        )}

        <div className="panel full padded">
          <h2>Your Agreements</h2>
          {this.state.loading ? (<div>Loading...</div>) : (
            <table>
              <thead>
                <tr>
                  <th>Document</th>
                  <th>Status</th>
                </tr>
              </thead>
              {this.renderUserAgreement()}
              {this.renderLegacyAgreements()}
            </table>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/Agreements.js